<boi-contextual-help-container
  [contextualHelpName]="labelName">
  <boi-validation-error [propertyNames]="['ApplicationProduct_0.ApplicationProductRepaymentMethods']">
  </boi-validation-error>
  <ng-container *ngFor="let method of data; index as methodIndex">
    <boi-validation-error
      [propertyNames]="['ApplicationProduct_0.ApplicationProductRepaymentMethod_' + methodIndex + '.RepaymentMethodCode']">
    </boi-validation-error>
  </ng-container>
  <kendo-textbox-container class="form-element app">
    <div class="form-label app" [boiRequiredFormField]="labelName">
      <label>{{labelName | localizeLabel}}</label>
    </div>
    <div class="form-input-container display-column">
      <div class="checkbox-container"
        *ngFor="let method of (getRepaymentMethodCodes()|localizeOptionList); index as methodIndex">
        <input kendoCheckbox type="checkbox" [ngModel]="hasElementSelected(method.Code)"
          (ngModelChange)="onRepaymentMethodChange(method.Code)" [id]="method.Code" #formCheckBox class="k-checkbox"
          [disabled]="isFieldDisabled || (isExclusiveOptionSelected && method.Code !== exclusiveOptionCode)">
        <label class="k-checkbox-label ml-15" for="{{method.Code}}" [innerHtml]="method.Value"></label>
        <br>
      </div>
    </div>
  </kendo-textbox-container>
</boi-contextual-help-container>